package com.wintermar.inspection.core.ui.util.modifier

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun Modifier.badge(
    backgroundColor: Color = LocalAppTheme.current.color.surface.normal,
    borderColor: Color = LocalAppTheme.current.color.border.subtle,
    radius: Dp = LocalAppTheme.current.dimension.radius.full,
    verticalPadding: Dp = LocalAppTheme.current.dimension.spacing.space1,
    horizontalPadding: Dp = LocalAppTheme.current.dimension.spacing.space2
) = this
    .clip(RoundedCornerShape(radius))
    .background(backgroundColor)
    .border(
        width = 1.dp,
        color = borderColor,
        shape = RoundedCornerShape(radius)
    )
    .padding(
        vertical = verticalPadding,
        horizontal = horizontalPadding
    )
